/**
 * @author Akshay Kumar Singh
 * @file ScoringManagement Component
 * @flow
 */
import React, { useState, useEffect } from 'react';
import AlertModal from '../../shared/modals/AlertModal';
import { spinnerService } from '../../shared/services/spinner.service';
import { CallApi } from '../../shared/services/api.service'
import CONFIG from '../../configuration/config';
import { useHistory } from "react-router-dom";
import SubHeaderComponent from '../common/HeaderComponent/SubHeaderComponent';
import { setData, getData } from '../../shared/utils/storage.util';
import { LABLES, STRINGS } from '../../shared/constants/data';

const ScoringManagementComponent = () => {
  const history = useHistory();
  const [state, setState] = useState({
    auditTypeArr: [
      { auditId: 1, auditName: 'Work Order Compliance' },
      { auditId: 2, auditName: 'Parts Room Inventory Compliance' },
      { auditId: 3, auditName: 'Line Equipment and Injection' },
      { auditId: 4, auditName: 'Facilities' },
      { auditId: 5, auditName: 'Utilities' }
    ],
    dataArr: [],
    selectedDataArr: []
  });

  const [auditType, setAuditType] = useState(state.auditTypeArr[0]);
  const [totalScore, setTotalScore] = useState(0);
  const [counter, setCounter] = useState(0);

  /**
   * @description This function is react life cycle hook which sets initial values whenever the component loads.
   */
  useEffect(() => {
    getSectionalScoring();
  }, []);

  useEffect(() => {
    calculateTotalScore();
  }, [state.selectedDataArr, counter])

  const handleChange = (event) => {
    const { auditTypeArr, dataArr, selectedDataArr } = state;
    const { name, value, id } = event.target;
    if (name === "auditType") {
      setAuditType(auditTypeArr[value - 1]);
      let selectedDataArr = getData('scoringData').filter(element => element.audit_code == auditTypeArr[value - 1].auditId);
      setState({
        ...state, selectedDataArr
      })
    }
    if (name === 'section_weightage') {
      selectedDataArr[id].section_weightage = parseInt(value) || 0;
      setState({
        ...state, selectedDataArr
      })
    }
    setCounter(counter + 1)
  }

  const calculateTotalScore = () => {
    let { selectedDataArr } = state;
    let totalScore = 0;
    for (let item of selectedDataArr) {
      totalScore += item.section_weightage
    }
    setTotalScore(totalScore);
  }

  /**
   * @description This function restrict alphabets and special characters and only allows numbers upto two decimal places.
   */
  const restrictToNumber = (event, data) => {
    let { value } = event.target;
    let numRejex = /^\d*\.?\d{0,2}$/;
    if (numRejex.test(value)) {
      if (value <= 100) {
        handleChange(event);
      }
    }
  }

  const getSectionalScoring = async () => {
    spinnerService.show(LABLES.Oval, STRINGS.FetchPlant);
    await CallApi(LABLES.GET, CONFIG.sectionWeightage, {}, {}, '', getsectionWeightage, history);
  }

  /**
   * @description Plant List API callback function
   * @param response This is the response structure received from API
   */
  const getsectionWeightage = (response) => {
    const { dataArr } = state;
    if (response?.success) {
      setData('scoringData', response.response)
      setState({ ...state, dataArr: response.response, selectedDataArr: response.response.filter(element => element.audit_code == auditType.auditId) });
    }
  }

  const handleUpdate = () => {
    const { selectedDataArr } = state
    let data = [];
    for (let item of selectedDataArr) {
      let { section_id, audit_code, section_weightage } = item;
      data.push({ section_id, audit_code, section_weightage });
    }
    if (totalScore == 100)
      updateScoreing(data);
    else
      AlertModal.showAlert(STRINGS.SCOREERROR);
  }

  const updateScoreing = async (data) => {
    spinnerService.show(LABLES.Oval, STRINGS.FetchPlant);
    await CallApi(LABLES.PUT, CONFIG.sectionWeightage, {}, data, '', updateScore, history);
  }

  const updateScore = (response) => {
    if (response?.success) {
      getSectionalScoring();
    }
  }

  return (
    <React.Fragment>
      <SubHeaderComponent page={4} pageName={LABLES.ScoringManagement} />
      <div className="super-admin">
        <label>{STRINGS.SECTIONALSCORING}</label>
        <select className="form-control" name='auditType' onChange={handleChange} value={auditType.auditId} >
          <option value='' hidden>{STRINGS.SELECTAUDITTYPE}</option>
          {state.auditTypeArr.map((data, index) => {
            return (
              <option key={data.auditId} value={data.auditId} >
                {data.auditName}
              </option>
            )
          })}
        </select>
      </div>
      <div className="super-admin super-admin-form">
        {state.selectedDataArr.map((item, index) => {
          return (
            <div className="form-row score-row" key={index}>
              <div className="column-two">
                <div className="form-group">
                  <div className="form-control section-label">{item.section_type}</div>
                </div>
              </div>
              <div className="column-two">
                <div className="form-group">
                  <input className="form-control" type="text" id={index} name="section_weightage" value={item.section_weightage} onChange={restrictToNumber} />
                </div>
              </div>
            </div>
          )
        })}
        <div className="form-row score-row">
          <div className="column-two">
            <div className="form-group">
              <div className="form-control section-label">{LABLES.TotalWeightage}</div>
            </div>
          </div>
          <div className="column-two">
            <div className="form-group">
              <div className="form-control section-label">{totalScore}</div>
            </div>
          </div>
        </div>
        <div className="submition-outer">
          <button type='button' className="btn-prmry" onClick={handleUpdate}>
            {LABLES.UpdateWeightage}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ScoringManagementComponent;